import script from "./TicketingForInclusivity.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketingForInclusivity.vue?vue&type=script&setup=true&lang=js"

import "./TicketingForInclusivity.vue?vue&type=style&index=0&id=79cb6e8c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79cb6e8c"]])

export default __exports__